import { graphql, useStaticQuery } from 'gatsby';

import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

const SEO = ({
  title, description, image, article, location,
}) => {
  const { site } = useStaticQuery(query);
  const { pathname } = location;
  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    siteUrl,
    defaultImage,
    twitterUsername,
    phone,
  } = site.siteMetadata;

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
  };
  useEffect(() => {
    console.log('loca', location);
  }, [location]);

  return (
    <Helmet
      title={seo.title}
      titleTemplate={titleTemplate}
    >
      <meta
        name="description"
        content={seo.description}
      />
      <meta
        name="image"
        content={seo.image}
      />

      {seo.url && (
      <meta
        property="og:url"
        content={seo.url}
      />
      )}

      {(article ? true : null) && (
      <meta
        property="og:type"
        content="article"
      />
      )}

      {seo.title && (
      <meta
        property="og:title"
        content={seo.title}
      />
      )}

      {seo.description && (
        <meta
          property="og:description"
          content={seo.description}
        />
      )}

      {seo.image && (
      <meta
        property="og:image"
        content={seo.image}
      />
      )}

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      {twitterUsername && (
        <meta
          name="twitter:creator"
          content={twitterUsername}
        />
      )}

      {seo.title && (
      <meta
        name="twitter:title"
        content={seo.title}
      />
      )}

      {seo.description && (
        <meta
          name="twitter:description"
          content={seo.description}
        />
      )}

      {seo.image && (
      <meta
        name="twitter:image"
        content={seo.image}
      />
      )}
      <meta
        property="og:image"
        content={`${site.siteMetadata.siteUrl}/opengraph-gen.png`}
      />
      <meta
        property="og:image:width"
        content="400"
      />
      <meta
        property="og:image:width"
        content="50"
      />
      <script type="application/ld+json">
        {`
         "@context": "https://schema.org",
         "@type": "Real Estate Investor",
          "name": "${seo.title}",
          
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "44250 Old Warm Springs Blvd #10",
            "addressLocality": "Fremont",
            "addressRegion": "CA",
            "postalCode": "94538",
            "addressCountry": "US"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 37.507912,
            "longitude": -121.947052
          },
          "url": "${seo.url}",
          "telephone": "${phone}",
        
      `}
      </script>
    </Helmet>
  );
};

export default SEO;

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
};

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
};

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl
        phone
        defaultImage: image
        twitterUsername
      }
    }
  }
`;
